import {
  StudioListPage,
  StudioEditPage,
  StudioCreatePage,
  ProductTypeListPage,
  ProductTypeEditPage,
  ProductLineListPage,
  ProductLineEditPage,
  BusinessUnitListPage,
  BusinessUnitEditPage,
  BusinessLineListPage,
  BusinessLineEditPage,
  ProductTypeCreatePage,
  ProductLineCreatePage,
  TermConditionListPage,
  TermConditionEditPage,
  BusinessUnitCreatePage,
  BusinessLineCreatePage,
  TermConditionCreatePage,
  ExternalityReasonsListPage,
  ExternalityReasonsEditPage,
  ExternalityReasonsCreatePage,
} from './imports';

export const portfolioGeneralRoutes = [
  {
    path: 'general',
    children: [
      { element: <ProductTypeListPage />, index: true },
      { path: 'list', element: <ProductTypeListPage /> },
      { path: ':id/edit', element: <ProductTypeEditPage /> },
      { path: 'new', element: <ProductTypeCreatePage /> },
      {
        path: 'business-units',
        children: [
          { element: <BusinessUnitListPage />, index: true },
          { path: 'list', element: <BusinessUnitListPage /> },
          { path: 'new', element: <BusinessUnitCreatePage /> },
          { path: ':id/edit', element: <BusinessUnitEditPage /> },
        ],
      },
      {
        path: 'business-lines',
        children: [
          { element: <BusinessLineListPage />, index: true },
          { path: 'list', element: <BusinessLineListPage /> },
          { path: ':id/edit', element: <BusinessLineEditPage /> },
          { path: 'new', element: <BusinessLineCreatePage /> },
        ],
      },
      {
        path: 'product-lines',
        children: [
          { element: <ProductLineListPage />, index: true },
          { path: 'list', element: <ProductLineListPage /> },
          { path: 'new', element: <ProductLineCreatePage /> },
          { path: ':id/edit', element: <ProductLineEditPage /> },
        ],
      },
      {
        path: 'studios',
        children: [
          { element: <StudioListPage />, index: true },
          { path: 'list', element: <StudioListPage /> },
          { path: 'new', element: <StudioCreatePage /> },
          { path: ':id/edit', element: <StudioEditPage /> },
        ],
      },
      {
        path: 'term-conditions',
        children: [
          { element: <TermConditionListPage />, index: true },
          { path: 'list', element: <TermConditionListPage /> },
          { path: 'new', element: <TermConditionCreatePage /> },
          { path: ':id/edit', element: <TermConditionEditPage /> },
        ],
      },
      {
        path: 'externality-reasons',
        children: [
          { element: <ExternalityReasonsListPage />, index: true },
          { path: 'list', element: <ExternalityReasonsListPage /> },
          { path: 'new', element: <ExternalityReasonsCreatePage /> },
          { path: ':id/edit', element: <ExternalityReasonsEditPage /> },
        ],
      },
    ],
  },
];
